import { failureSignature } from './callFormat';

/**
 * Which call failures this admin has already looked at, shared by the Calls bell and the
 * softphone's "My recent calls" tab so opening either clears the other's badge. Keyed by call id,
 * valued by the failure's signature (step + message), so a note edit or a nightly re-run that
 * changes nothing does not re-light a badge, while a new failure on the same call does.
 * Persisted per browser in localStorage; every access is guarded, so a blocked store just means
 * badges reset on reload.
 */
const SEEN_KEY = 'voice.activity.seenFailures';

export const readSeenFailures = () => {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {}; } catch { return {}; }
};

const writeSeenFailures = (seen) => {
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch { /* ignore */ }
};

/** How many of these cards carry a failure not yet marked seen. */
export const countUnseenFailures = (cards, seen) =>
    (cards || []).reduce((n, c) => { const sig = failureSignature(c); return sig && seen?.[c.id] !== sig ? n + 1 : n; }, 0);

/** Mark every failure among these cards as seen; returns the new map (and persists it). Unchanged input → same object. */
export const markFailuresSeen = (cards, seen) => {
    let next = seen || {};
    let changed = false;
    for (const c of cards || []) {
        const sig = failureSignature(c);
        if (sig && next[c.id] !== sig) { if (!changed) { next = { ...next }; changed = true; } next[c.id] = sig; }
    }
    if (changed) writeSeenFailures(next);
    return next;
};
